import { graphql } from 'react-relay';

import useQuery from '@zego/hooks/useQuery';

const query = graphql`
  query useOnlineCheckoutProgressQuery($category: String!) {
    viewer {
      onlineCheckoutProgress(category: $category) {
        categoryCode
        status
        currentCheck
        selectedProduct {
          code
        }
        onlineCheckoutEnabled
      }
    }
  }
`;

export default function useOnlineCheckoutProgress() {
  const call = useQuery(query);

  return async function onlineCheckoutProgress(category) {
    const result = await call({ category });
    return result.viewer.onlineCheckoutProgress;
  };
}
